import { createSlice } from "@reduxjs/toolkit";
import { searchPharmacyMedicinesForDoctor } from "../../reducer/searchPharmacyMedicinesForDoctor/searchPharmacyMedicinesForDoctorReducer";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const searchPharmacyMedicinesForDoctorSlice = createSlice({
  name: "searchPharmacyMedicinesForDoctor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchPharmacyMedicinesForDoctor.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(searchPharmacyMedicinesForDoctor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(searchPharmacyMedicinesForDoctor.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default searchPharmacyMedicinesForDoctorSlice.reducer;
